import contractsAPI from "@/api/products/contracts";

const getDefaultState = () => ({
  contracts: [],
  isContractsLoading: false,
  isContractsError: false,
  isContractsErrorResponse: null,

  isDownloadContractLoading: {},
  isDownloadContractError: false,
  isDownloadContractErrorResponse: null,

  paginationConfigs: {
    paginationCount: 0,
    itemsPerPage: 25,
    page: 1,
  },
});

const state = getDefaultState();

const mutations = {
  FETCH_CONTRACTS_BEGIN(state) {
    state.isContractsLoading = true;
    state.isContractsError = false;
    state.isContractsErrorResponse = null;
  },
  FETCH_CONTRACTS_SUCCESS(state, payload) {
    state.contracts = payload.data;
    state.paginationConfigs.paginationCount = parseInt(payload.headers['pagination-count']);
    state.paginationConfigs.itemsPerPage = parseInt(payload.headers['pagination-limit']);
    state.paginationConfigs.page = parseInt(payload.headers['pagination-page']);
    state.isContractsLoading = false;
  },
  FETCH_CONTRACTS_ERROR(state, err) {
    state.isContractsLoading = false;
    state.isContractsError = true;
    state.isContractsErrorResponse = err;
  },

  DOWNLOAD_CONTRACT_BEGIN(state, identifier) {
    this._vm.$set(state.isDownloadContractLoading, identifier, true);
    state.isDownloadContractError = false;
    state.isDownloadContractErrorResponse = null;
  },
  DOWNLOAD_CONTRACT_SUCCESS(state, identifier) {
    this._vm.$delete(state.isDownloadContractLoading, identifier);
  },
  DOWNLOAD_CONTRACT_ERROR(state, { identifier, err }) {
    this._vm.$delete(state.isDownloadContractLoading, identifier);
    state.isDownloadContractError = true;
    state.isDownloadContractErrorResponse = err;
  },
  
  RESET_CONTRACT_STORE(state) {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchContracts({ commit, dispatch }, { id, options }) {
    commit("FETCH_CONTRACTS_BEGIN");
    try {
      let res = await contractsAPI.fetchContracts(id, options);
      commit("FETCH_CONTRACTS_SUCCESS", res);
    } catch(err) {
      commit("FETCH_CONTRACTS_ERROR", err.response.data.message);
      dispatch("alerts/setAlert", { type: "error", message: error.response.data.message }, { root: true });
    }
  },

  async downloadContract({ commit, dispatch }, { type, id }) {
    let contract = null;
    let identifier = `${type}-${id}`;

    commit("DOWNLOAD_CONTRACT_BEGIN", identifier);

    try {
      switch(type) {
        case "contract":
          contract = await contractsAPI.fetchContractPDF(id);
          break;
        case "summary":
          contract = await contractsAPI.fetchContractSummaryPDF(id);
          break;
        case "information":
          contract = await contractsAPI.fetchContractInformationPDF(id);
          break;        
      }

      if(contract.status === 200) {
        const url = window.URL.createObjectURL(contract.data)
        const link = document.createElement('a');
        link.href = url;
        link.download = contract.headers["content-disposition"].split("=")[1];
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
        commit("DOWNLOAD_CONTRACT_SUCCESS", identifier);
      } else {
        throw "Error downloading contract";
      }
    } catch(err) {
      const error = JSON.parse(await err.response.data.text());
      commit("DOWNLOAD_CONTRACT_ERROR", { identifier, err: error ? error.message : err });
      dispatch("alerts/setAlert", { type: "error", message: error ? error.message : err }, { root: true });
    }
  },
};

const getters = {
  getContracts: state => state.contracts,
  getIsContractsLoading: state => state.isContractsLoading,
  getIsContractsError: state => state.isContractsError,
  getIsContractsErrorResponse: state => state.isContractsErrorResponse,
  getPaginationConfigs: state => state.paginationConfigs,

  getIsDownloadContractLoading: state => (type, id) => !!state.isDownloadContractLoading[`${type}-${id}`],
  getIsDownloadContractError: state => state.isDownloadContractError,
  getIsDownloadContractErrorResponse: state => state.isDownloadContractErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
